"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CommonAptosUtilsConfig = void 0;
exports.CommonAptosUtilsConfig = {
    defaultAptosNetwork: {
        name: 'defaultAptosNetwork',
        defaultValue: 'mainnet',
    },
};
//# sourceMappingURL=CommonAptosUtilsConfig.js.map